import { Droppable } from '@hello-pangea/dnd';
import { Box,Stack,Typography,useTheme } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChecklistModel,FluxoState } from '../../types/fluxo/types';
import AccomplishCard from './AccomplishCard';

type AccomplishChecklistProps = {
  modelo: ChecklistModel;
  nome: string;
  execucoes: FluxoState[];
  totalExecucoes: number;
  handleCancelEdit: (id: string) => void;
  updateFirestore: (id: string, droppableId: string, selectedUnidade: string | null, date: number | null) => void;
  itensEditing: Set<string>;
  selectedIds: Set<string>;
  toggleSelection: (id: string, multiSelect?: boolean) => void;
  statusById: Record<string, undefined | "saving" | "queuedOffline" | "error">;
  draggingId?: string | null;
  disableDrop?: boolean;
};

const AccomplishChecklist = ({ modelo, nome, execucoes, totalExecucoes, handleCancelEdit, updateFirestore,
  itensEditing, selectedIds, toggleSelection, statusById, draggingId, disableDrop }: AccomplishChecklistProps) => {
  const { t } = useTranslation('translation');
  const theme = useTheme();

  return (
    <Stack key={modelo.checklistId} direction='column' minWidth={300} width='100%' height='100%' padding={1}>
      <Stack direction={'row'} spacing={2} padding={1}>
        <Typography variant="body1" fontWeight={'bold'}>{nome}</Typography>
        <Typography variant="body1" sx={{ opacity: 0.5 }} >{totalExecucoes}</Typography>
      </Stack>
      <Droppable isDropDisabled={disableDrop} droppableId={modelo.checklistId}>
        {(provided, snapshot) => (
          <Box {...provided.droppableProps} ref={provided.innerRef}
            className={snapshot.isDraggingOver ? "isDraggingOver" : ""}
            padding={1}
            borderRadius={2}
            paddingBottom='20%'
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              height: "100%",
              transition: '0.2s',
              "&.isDraggingOver": { bgcolor: theme.palette.action.hover }
            }}>
            {totalExecucoes > 0 ? execucoes.map((execucao, index) => (
              <AccomplishCard key={execucao.id} execucao={execucao} index={index}
                nomeFormulario={nome}
                handleCancelEdit={handleCancelEdit}
                droppableId={modelo.checklistId}
                updateFirestore={updateFirestore}
                isEditing={itensEditing.has(execucao.id)}
                isSelected={selectedIds.has(execucao.id)}
                toggleSelection={toggleSelection}
                selectedCount={draggingId === execucao.id ? selectedIds.size : 0}
                isSaving={statusById[execucao.id] === "saving"}
                isError={statusById[execucao.id] === "error"} />
            )) : <Typography color='textDisabled' variant="h6" textAlign='center' paddingY='20%'>{t('fluxo.noExecutions')}</Typography>}
            {provided.placeholder}
          </Box>
        )}
      </Droppable>
    </Stack>
  );
};

export default React.memo(AccomplishChecklist);
